import { render, staticRenderFns } from "./UploadJSON.vue?vue&type=template&id=39536e4a&"
import script from "./UploadJSON.vue?vue&type=script&lang=js&"
export * from "./UploadJSON.vue?vue&type=script&lang=js&"
import style0 from "./UploadJSON.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports